import "./ExperienceSection.css";

const CheckIcon = () => (
	<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
		<path
			d="M5 13l4 4L19 7"
			stroke="currentColor"
			strokeWidth="3"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

const HIGHLIGHTS = [
	"Composed and mastered at 432 Hz for natural resonance",
	"Layered traditional Asian instruments with ambient textures",
	"Designed to deepen meditation, focus, and devotional practice",
];

const ExperienceSection = () => (
	<section className="experience-section">
		<div className="experience-grid">
			<div>
				<span className="experience-eyebrow">A taste of the sound</span>
				<h2 className="experience-heading">
					Press play and step into the BodhiStreams sound.
				</h2>
				<p className="experience-lead">
					Words can only do so much — take a moment to actually hear what we
					mean by mindful music. This short preview captures the calm, grounded,
					intentional feel of every collection on the platform.
				</p>
				<ul className="experience-highlights">
					{HIGHLIGHTS.map((item) => (
						<li key={item} className="experience-highlight">
							<span className="experience-highlight-icon">
								<CheckIcon />
							</span>
							<span>{item}</span>
						</li>
					))}
				</ul>
			</div>

			<div className="experience-frame">
				<div className="experience-frame-inner">
					<span className="experience-corner is-tl" aria-hidden="true" />
					<span className="experience-corner is-tr" aria-hidden="true" />
					<span className="experience-corner is-bl" aria-hidden="true" />
					<span className="experience-corner is-br" aria-hidden="true" />
					<div className="experience-video-wrap">
						<iframe
							title="BodhiStreams preview"
							src="https://www.youtube.com/embed/0aZ3CWNGU0E?autoplay=1&mute=1&controls=1&modestbranding=1&loop=1&playlist=0aZ3CWNGU0E&rel=0"
							allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
							allowFullScreen
						/>
					</div>
				</div>
			</div>
		</div>
	</section>
);

export default ExperienceSection;
